'use client';

import { UserIcon } from '@/components/icons';
import { Dropdown, DropdownItem } from '@/components/molecules/Dropdown';
import { Button } from '@/components/atoms/Button';
import classNames from 'classnames';
import { useAuth } from '@/modules/auth';
import { useRouter } from 'next/navigation';
import { useProfile } from '@/modules/profile/hooks/useProfile';

export const AccountSettingsDropdown = () => {
  const { signOut, user } = useAuth();
  const { profileData } = useProfile();
  const router = useRouter();

  const handleLogout = () => {
    signOut();
  };

  const handleProfile = () => {
    router.push('/dashboard/profile');
  };

  const dropdownItems: DropdownItem[] = [
    {
      id: 'profile',
      label: 'Profile',
      onClick: handleProfile,
    },
    {
      id: 'logout',
      label: 'Sign Out',
      onClick: handleLogout,
    },
  ];

  const formatUserName = (userName: string) => {
    const parts = userName.split(' ');
    if (parts.length >= 2) {
      // Take first name + last name (assuming format is "Last First Middle...")
      return `${parts[0]} ${parts[1]}`;
    }
    return userName;
  };

  const displaySubtext = profileData?.UserFirstName && profileData?.UserLastName ? formatUserName(`${profileData.UserFirstName} ${profileData.UserLastName}`) : user?.userName ? formatUserName(user?.userName) : '—';

  return (
    <Dropdown
      trigger={
        <Button variant="ghost" className={classNames('text-white')}>
          <div className="flex items-center gap-2">
            <div className="w-[24px] h-[24px]">
              <UserIcon />
            </div>
            <span style={{ fontFamily: 'Roboto, sans-serif' }}>{displaySubtext}</span>
          </div>
        </Button>
      }
      items={dropdownItems}
      showChevron={false}
      align="right"
    />
  );
};
